module.exports = __webpack_public_path__ + "media/images/common/header_menu_inq-0459b9b90f49f89e623d7bd3b23bdf8f.png";